// extracted by mini-css-extract-plugin
export default {"marquee-content":"Marquee_marquee-content__HwWz4"};